<div class="table-container table-items">
    <app-add-reference-card [desc]="'You have no items.'" *ngIf="dataSource.data.length < 1">
    </app-add-reference-card>
    <!-- Table Section -->
    <div class="table-container table-items" *ngIf="dataSource.data.length>0">
        <div class="table-wrapper">
            <table mat-table [dataSource]="dataSource" matSort class="rfq-summary-items-table">
                <ng-container *ngFor="let column of itemColumns" [matColumnDef]="column.columnDef">
                    <ng-container *ngIf="column.columnDef == 'Select'">
                        <th mat-header-cell *matHeaderCellDef>
                            <mat-checkbox (change)="$event ? toggleAllRows() : null"
                                [checked]="isAllSelected"
                                [indeterminate]="isIndeterminate"
                                [aria-label]="checkboxLabel()">
                            </mat-checkbox>
                        </th>
                        <td mat-cell *matCellDef="let row">
                            <mat-checkbox (click)="$event.stopPropagation()"
                                (change)="onRecordClick(row)"
                                [checked]="isSelected(row)"
                                [aria-label]="checkboxLabel(row)">
                            </mat-checkbox>
                        </td>
                    </ng-container>
                    <ng-container *ngIf="column.columnDef != 'Select'">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header>
                            <div style="text-align: left;">{{column.header}}</div>
                            <!-- <div class="sub-header" *ngIf="column.columnDef === 'PONumber'">
                                <span class="green-circle"></span>
                                <span class="text paragraph-small-regular">PO submitted</span>
                            </div> -->
                        </th>
                        <ng-container *ngIf="column.columnDef === 'Vendor'">
                            <td mat-cell *matCellDef="let row">
                              <div [innerHTML]="column.cell(row)"></div>
                            </td>
                        </ng-container>
                        <ng-container *ngIf="column.columnDef === 'PONumber'">
                            <td mat-cell *matCellDef="let row">
                              <div [innerHTML]="column.cell(row)"></div>
                            </td>
                        </ng-container>
                        <ng-container *ngIf="column.columnDef === 'PODocStatus'">
                            <td mat-cell *matCellDef="let row">
                              <div [innerHTML]="column.cell(row)"></div>
                            </td>
                        </ng-container>
                        <ng-container *ngIf="column.columnDef === 'AwardedQuantity'">
                            <td mat-cell *matCellDef="let row">
                              <div [innerHTML]="column.cell(row)"></div>
                            </td>
                        </ng-container>
                        <ng-container *ngIf="column.columnDef == 'ReasonForAbort'">
                            <td mat-cell *matCellDef="let row" class="reason-for-abort">
                                <span *ngIf="row.ReasonForAbort">{{row.ReasonForAbort?.Name}}</span>
                                <span  *ngIf="!row.ReasonForAbort" style="color: #9EA0A2;">Not yet selected</span>
                                <!-- {{ row.ReasonForAbort?.Name || "Not yet selected"}} -->
                            </td>
                        </ng-container>
                        <ng-container *ngIf="column.columnDef != 'ReasonForAbort'">
                            <td mat-cell *matCellDef="let row"> {{ column.cell(row) }} </td>
                        </ng-container>
                    </ng-container>
                </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
        </div>
        <mat-paginator *ngIf="dataSource.data.length > 0" #RFQSummaryitemPg [length]="dataSource.data.length"
            [pageSize]="5" [pageSizeOptions]="pageSizeOptions" showFirstLastButtons></mat-paginator>
    </div>
</div>